import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'
import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'

export const fetchP360PartnerFlags = async (): Promise<IP360PartnerFlags[]> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPDashboardPartnerFlags/call`)

  const [accessToken] = getTokens()
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, headers })
    return response.Data
  } catch (e) {
    Logger.error(e)
    return []
  }
}
